import script from "./SecScorer.vue?vue&type=script&setup=true&lang=js"
export * from "./SecScorer.vue?vue&type=script&setup=true&lang=js"

import "./SecScorer.vue?vue&type=style&index=0&id=55470b68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55470b68"]])

export default __exports__